/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * MapIcon is an icon class that you can use with Leaflet.Marker for custom markers.
 */
import Leaflet, { Point } from 'leaflet';

type Options = {
  iconUrl: string;
  iconSize: Point; // Alternatively, can be set through CSS
  iconAnchor: Point; // Centered by default, can be set in CSS with negative margins
  popupAnchor: Point; // If not specified, popup opens in the anchor point
  shadowUrl: string; // No shadow by default
  shadowSize: Point;
  shadowAnchor: Point;
  className: string;
};

const MapIcon = Leaflet.Class.extend({
  initialize(options: Options) {
    this.options = Object.assign({}, options);
  },

  createIcon(oldIcon: Element) {
    return this._createIcon('icon', oldIcon);
  },

  createShadow(oldIcon: Element) {
    return this._createIcon('shadow', oldIcon);
  },

  _createIcon(name: string, oldIcon: Element) {
    let el = this._createIconEl(
      name,
      oldIcon && oldIcon.tagName ? oldIcon : null,
    );
    this._setIconStyles(el, name);
    return el;
  },

  _setIconStyles(el: Element, name: string) {
    let options = this.options;
    let size = Leaflet.point(options[name + 'Size']);
    let anchor = Leaflet.point(
      name === 'shadow' ? options.shadowAnchor : options.iconAnchor,
    );
    if (anchor == null && size != null) {
      anchor = size.divideBy(2, true);
    }
    el.classList.add('leaflet-marker-' + name);
    if (options.className) {
      el.classList.add(options.className);
    }
    let style: ObjectOf<any> = el ? (el as any).style : null;
    if (anchor && style) {
      style.marginLeft = -anchor.x + 'px';
      style.marginTop = -anchor.y + 'px';
    }
    if (size && style) {
      style.width = size.x + 'px';
      style.height = size.y + 'px';
    }
  },

  _createIconEl(name: string, el: Element | null | undefined): Element {
    let src = this._getIconUrl(name);
    if (el) {
      while (el.firstChild) {
        el.removeChild(el.firstChild);
      }
    } else {
      el = document.createElement('div');
    }
    if (src) {
      let img = document.createElement('img');
      img.src = src;
      el.appendChild(img);
    }
    return el;
  },

  _getIconUrl(name: string) {
    return this.options[name + 'Url'];
  },
});

export default MapIcon;
